import React from 'react';
import { Input } from '../../../../components/forms/Input';
import { useForm } from 'react-hook-form';
import { FormOptions } from '../../../../constants/form';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { FormModal } from '../../../../components/containers/FormModal';
import { Void } from '../../../../models/basic-objects';
import { ValidationMessages } from 'constants/validation-messages';

export type AddMediaByUrlModalViewProps = {
  onClose: Void;
  onSubmit: (url: string) => void;
};

export const AddMediaByUrlModalView = (props: AddMediaByUrlModalViewProps): JSX.Element => {
  const formInstance = useForm({
    ...FormOptions
  });

  const onSubmitHandler: SubmitHandler<{ addByUrl: string }> = (data: { addByUrl: string }) => {
    props.onSubmit(data.addByUrl);
  };

  return (
    <FormModal
      size={'large'}
      onClose={props.onClose}
      showCloseIcon={true}
      title={'Paste an Image URL from the Web'}
      formInstance={formInstance}
      loading={false}
      onSubmit={onSubmitHandler}
      submitText={'Get Image'}>
      <div>
        <ul>
          <li>Right-click on an image or GIF on the Web</li>
          <li>Copy the image URL/address</li>
          <li>Paste it into the box below</li>
        </ul>
      </div>
      <div>
        <Input
          formInstance={formInstance}
          name={'addByUrl'}
          rules={{ required: ValidationMessages.media.addByUrl.required }}
          size={'large'}
          label={'Image URL from the Web'}
        />
      </div>
    </FormModal>
  );
};
